export const ELEMENT_NAMES = {
	ROOT: 'with-loading',
	SPINNER: 'with-loading__spinner',
};
